/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "../reports.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { formatNumber } from "../../../../helper/numberFormatter";
import formatDate from "../../../../helper/dateFormatter";

const InventoryReceiveTable = (props) => {
  return (
    <div className={classes.root}>
      <TableContainer>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell className="global-custom-sorting-header">
                <b>{props.t("WAREHOUSE")}</b>
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("productId");
                }}
              >
                <b>{props.t("PRODUCT_ID")}</b>
                {/* Sort indication */}
                {props.sortBy === "productId" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("productName");
                }}
              >
                <b>{props.t("PRODUCT_NAME")}</b>
                {/* Sort indication */}
                {props.sortBy === "productName" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("receiptId");
                }}
              >
                <b>{props.t("RECEIPT_ID")}</b>
                {/* Sort indication */}
                {props.sortBy === "receiptId" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("orderId");
                }}
              >
                <b>{props.t("ORDER_ID")}</b>
                {/* Sort indication */}
                {props.sortBy === "orderId" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>

              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("serialNo");
                }}
              >
                <b>{props.t("SERIAL_NO")}</b>
                {/* Sort indication */}
                {props.sortBy === "serialNo" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("lotId");
                }}
              >
                <b>{props.t("LOT_ID")}</b>
                {/* Sort indication */}
                {props.sortBy === "lotId" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("QOHQty");
                }}
              >
                <b>{props.t("QOH_QTY")}</b>
                {/* Sort indication */}
                {props.sortBy === "QOHQty" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("ATPQty");
                }}
              >
                <b>{props.t("ATP_QTY")}</b>
                {/* Sort indication */}
                {props.sortBy === "ATPQty" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("datetimeReceived");
                }}
              >
                <b>{props.t("RECEIVED_DATE")}</b>
                {/* Sort indication */}
                {props.sortBy === "datetimeReceived" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Show orders list */}
            {props.list.map((row, index) => (
              <TableRow
                key={index}
                className={classes.rowClass}
                // onClick={(e) => { navigate(`/order/${row.orderId}`) }}
              >
                <TableCell>{row.facilityName}</TableCell>
                <TableCell>{row.productId}</TableCell>
                <TableCell>{row.productName}</TableCell>
                <TableCell>{row.receiptId}</TableCell>
                <TableCell>{row.orderId}</TableCell>
                <TableCell>{row.serialNumber}</TableCell>
                <TableCell>{row.lotId}</TableCell>
                <TableCell>{row.qohqty}</TableCell>
                <TableCell>{row.atpqty}</TableCell>
                <TableCell>{formatDate(row.datetimeReceived)}</TableCell>
              </TableRow>
            ))}
            {/* If there is no orders to show */}
            {props.list.length === 0 && (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  {props.t("NO_DATA_FOUND")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {props.totalInventoryCount > 0 && (
        <div
          className="global-custom-pagination"
          style={{ background: "rgba(196, 196, 196, 0.2)" }}
        >
          <label style={{ float: "left", padding: "5px" }}>
            {props.t("TOTAL_RECORDS")}: {formatNumber(props.totalInventoryCount)}
          </label>
          <label>
            {props.t("ROWS_PER_PAGE")}:
            <Select
              value={props.rowsPerPage}
              onChange={props.handleChangeRowsPerPage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </label>
          <Pagination
            count={Math.ceil(props.totalInventoryCount / props.rowsPerPage)}
            onChange={props.handleChangePage}
            page={props.page}
            showFirstButton
            showLastButton
          />
        </div>
      )}
    </div>
  );
};

export default InventoryReceiveTable;
